interface IProps {
  size: number;
}

export const GoForwardIcon = ({ size }: IProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 13 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 16L6 12.25L11 8.5L1 1" stroke="currentColor" strokeWidth="2" />
  </svg>
);
